import Phaser from 'phaser';
import { NEON_PALETTE } from '@/utils/ColorUtils';

interface DanceFloorTile {
  col: number;
  row: number;
  sprite: Phaser.GameObjects.Image;
}

/**
 * Animates dance floor tiles with beat-synced color waves.
 * Uses setTint() for GPU-cheap color changes.
 */
export class DanceFloorAnimator {
  private tiles: DanceFloorTile[] = [];
  private colorIndex = 0;
  private pattern: 'wave' | 'checkerboard' = 'wave';

  setTiles(tiles: DanceFloorTile[]): void {
    this.tiles = tiles;
  }

  /** On beat: advance the color pattern */
  onBeat(beatCount: number): void {
    this.colorIndex = beatCount % NEON_PALETTE.length;
    // Alternate pattern every 4 beats
    this.pattern = Math.floor(beatCount / 4) % 2 === 0 ? 'wave' : 'checkerboard';
  }

  /** Update tile tints based on beat progress */
  update(beatProgress: number): void {
    if (this.tiles.length === 0) return;

    for (const tile of this.tiles) {
      let palIdx: number;

      if (this.pattern === 'checkerboard') {
        palIdx = ((tile.col + tile.row) % 2 === 0)
          ? this.colorIndex
          : (this.colorIndex + 3) % NEON_PALETTE.length;
      } else {
        // Wave pattern: color shifts based on position + time
        const wave = Math.sin((tile.col + tile.row) * 0.5 + beatProgress * Math.PI * 2);
        const offset = Math.floor((wave + 1) * 2);
        palIdx = (this.colorIndex + offset) % NEON_PALETTE.length;
      }

      tile.sprite.setTint(NEON_PALETTE[palIdx]);
    }
  }

  destroy(): void {
    this.tiles = [];
  }
}
